import { useTranslation } from 'react-i18next'
import { useOnlineStatus } from '@/hooks/useOnlineStatus'

export function OfflineBanner() {
  const { t } = useTranslation()
  const isOnline = useOnlineStatus()

  if (isOnline) return null

  return (
    <div
      role="status"
      className="border-b border-brass-dim bg-panel-2 px-4 py-2 text-center font-sans text-sm text-brass-dim"
    >
      {t('offline.banner')}
    </div>
  )
}
